import { AxiosRequestConfig } from "axios";

import { createApiQueryHook, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { getCertificationIssuerListQueryKey } from "../certificationIssuerQueryKey";
import { ICertificationIssuerList } from "../types";

export type ICertificationIssuerListQueryParameters = IPaginateable;
export type ICertificationIssuerListQueryResult = ICertificationIssuerList;

export function certificationIssuerListQuery({
    pagination,
}: ICertificationIssuerListQueryParameters): AxiosRequestConfig {
    return {
        method: "GET",
        url: `/certification_issuers${serialize({ ...mapPagination(pagination) }, true)}`,
    };
}

const useCertificationIssuerListApiQuery = createApiQueryHook<
    ICertificationIssuerListQueryParameters,
    ICertificationIssuerListQueryResult
>(certificationIssuerListQuery);

export const useCertificationIssuerListQuery = (
    parameters: ICertificationIssuerListQueryParameters,
    options: NonNullable<Parameters<typeof useCertificationIssuerListApiQuery>[1]> = {},
) => {
    const { queryKey, ...queryOptions } = options;

    return useCertificationIssuerListApiQuery(parameters, {
        ...queryOptions,
        queryKey: getCertificationIssuerListQueryKey(queryKey ?? parameters),
    });
};
